export default __webpack_public_path__ + "static/media/roboto-slab-700.7cb09bef.woff";